(function() {
  const addKitBtns = document.querySelectorAll('[data-kit-add-to-cart]');

  addKitBtns.forEach((btn) => {
    btn.addEventListener('click', disableAddKitBtns);
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (!cart) return;

    const foundKit = cart.items.find((item) => item.product_type === 'Kit');
    if (theme.is_partner || foundKit) {
      disableAddKitBtns();
      
      if (!foundKit) return;
      const addedKitBtn = document.querySelector(`[data-kit-add-to-cart][data-add-to-cart-variant="${foundKit.variant_id}"]`);
      if (addedKitBtn) {
        const addedKitBtnText = addedKitBtn.querySelector('[data-kit-add-to-cart-text]');
        if (addedKitBtnText) { 
          addedKitBtnText.textContent = window.theme.strings.selected;
          addedKitBtn.style.opacity = 1;
        }
      }
    } else {
      addKitBtns.forEach((btn) => {
        const onProductForm = btn.closest('product-form');
        const addKitBtnText = btn.querySelector('[data-kit-add-to-cart-text]');
        if (addKitBtnText) addKitBtnText.textContent = window.theme.strings.selectAndJoin;

        btn.removeAttribute('data-disabled-flag');
        if (onProductForm) {
          btn.dispatchEvent(
            new CustomEvent('theme:addButton:configure', {
              bubbles: true
            })
          );
        } else {
          btn.classList.remove('disabled');
          btn.disabled = false;
        }
      })
    }
  })

  function disableAddKitBtns() {
    addKitBtns.forEach((btn) => {
      const onProductForm = btn.closest('product-form');

      btn.setAttribute('data-disabled-flag', 'disabled');
      btn.classList.add('disabled');
      btn.disabled = true;
      
      if (onProductForm) {
        const addToCartText = btn.querySelector('[data-add-to-cart-text]');
        addToCartText.textContent = window.theme.strings.errors.limitOneProduct;
      }
    })
  }
})();